export default __webpack_public_path__ + "static/innotech-3f1870c54729a0c8f928a84b38288c41.svg";